import React from "react";
import Page from "@jumbo/shared/Page";
import DsokCustomerDetailProvider from "../data/DsokCustomerDetailProvider";
import DsokCustomerCartPage from "../pages/DsokCustomerCartPage";

export const dsokCustomerCartRoute = {
  path: "/dsok/customer-detail/:customerUrl/cart",
  element: (
    <DsokCustomerDetailProvider>
      <Page component={DsokCustomerCartPage} />
    </DsokCustomerDetailProvider>
  ),
};
